import { getCartErrorMessage } from '@theme/cart-feedback';

/**
 * <s-bundle-form> — adds several variants to the cart in one Standard Actions call
 * (routine bundles), then opens the cart drawer. Reads hidden inputs marked
 * [data-bundle-variant]; without Standard Actions the native items[][id] form posts.
 */
class SBundleForm extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('submit', (event) => {
      if (!window.Shopify?.actions?.updateCart) return;
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      event.preventDefault();
      if (this.getAttribute('aria-busy') === 'true') return;
      this.#submit(form);
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  async #submit(form) {
    const lines = [...form.querySelectorAll('[data-bundle-variant]')]
      .map((input) => ({ merchandiseId: input.value, quantity: 1 }))
      .filter((line) => line.merchandiseId);
    if (!lines.length) return;

    const error = this.querySelector('[data-add-to-cart-error]');
    if (error) error.hidden = true;
    this.setAttribute('aria-busy', 'true');

    try {
      const result = await window.Shopify.actions.updateCart({ lines }, { event: { context: 'product', detail: { source: 's-bundle-form' } } });
      const message = result?.userErrors?.[0]?.message;
      if (message) {
        this.#showError(message);
      } else {
        await window.Shopify.actions.openCart?.();
      }
    } catch (err) {
      this.#showError(getCartErrorMessage(err) || this.dataset.errorMessage || '');
    } finally {
      this.removeAttribute('aria-busy');
    }
  }

  #showError(message) {
    const error = this.querySelector('[data-add-to-cart-error]');
    if (!error) return;
    error.textContent = message;
    error.hidden = !message;
  }
}

if (!customElements.get('s-bundle-form')) {
  customElements.define('s-bundle-form', SBundleForm);
}
